module.exports = __webpack_public_path__ + "img/thumb-music-player.e6b5cace.png";